import styles from "./styles.module.css"

export default function Container({children, noPaddingTop, noPaddingBottom}) {
	return <div className={`${styles.root} ${noPaddingTop ? styles.noPaddingTop : null} ${noPaddingBottom ? styles.noPaddingBottom : null}`}>{children}</div>
}
